import {
  GroupByMode,
  ID,
  ReorderSectionUpdate,
  SortingMode,
  UserSettings,
} from '@griply/types';

export type BuildInboxReorderUserSettingsOptions = {
  updatedSections: ReorderSectionUpdate[];
  groupBy: GroupByMode | undefined | null;
};

export const buildInboxReorderUserSettings = ({
  updatedSections,
  groupBy,
}: BuildInboxReorderUserSettingsOptions): Partial<UserSettings> => {
  const groupByMode = groupBy ?? GroupByMode.None;

  // None mode collapses to a single flat section; the slot is `ID[]` not `Record<ID, ID[]>`.
  const noGroupingSorting =
    updatedSections.length === 1 && groupByMode === GroupByMode.None
      ? updatedSections[0].taskSorting
      : undefined;
  const groupBySorting =
    noGroupingSorting ??
    updatedSections.reduce<Record<ID, ID[]>>((acc, section) => {
      acc[section.id] = section.taskSorting;
      return acc;
    }, {});

  return {
    filters: { inbox: { sortingMode: SortingMode.Custom } },
    customTaskOrder: { inbox: { [groupByMode]: groupBySorting } },
  };
};
